import { GoldenSourceHelper } from "../../../app/Switch_Core_React_Standards";

/**
 * Standard "name / address / reg no" shape for a company, shared by every
 * screen that works with a specific company - same construction the
 * Company Dashboard uses.
 */
export const formatCompanyIdentity = (entity, address) => {
    const name = GoldenSourceHelper.get(entity, "EntityName") || "";
    const regNo =
        GoldenSourceHelper.get(entity, "TaxReference") ||
        GoldenSourceHelper.get(entity, "RegistrationNumber") ||
        "";
    const addressLine = address
        ? [
              GoldenSourceHelper.get(address, "Address_Line1"),
              GoldenSourceHelper.get(address, "Address_Line2"),
              [GoldenSourceHelper.get(address, "Address_Town"), GoldenSourceHelper.get(address, "Address_County")]
                  .filter(Boolean)
                  .join(", "),
              [GoldenSourceHelper.get(address, "Postal_Code"), GoldenSourceHelper.get(address, "Country_ISO2")]
                  .filter(Boolean)
                  .join(" "),
          ]
              .filter(Boolean)
              .join(", ")
        : "No registered address on file";

    return { name, addressLine, regNo };
};
